import SliderManager from "./SliderManager.js";

const partnersSlider = new SliderManager({
  selector: ".partners__list",
  splideOptions: {
    type: "loop",
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: false,
    fixedWidth: "282px",
    autoWidth: true,
    trimSpace: false,
    updateOnMove: true,
    waitForTransition: true,
    gap: "24px",
    mediaQuery: "min",
    breakpoints: {
      768: {
        perPage: 2,
        perMove: 1,
        autoWidth: false,
      },
    },
  },
  createCondition: () => window.innerWidth < 1280,
  globalVarName: "partnersSlider",
  resizeDelay: 250,
  dynamicWrapper: {
    trackClass: "partners__slider-track",
    itemClass: "partner-card",
  },
});

partnersSlider.init();
